//@flow

// Vendors
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { replace } from 'connected-react-router';

// Graphics
import { ReactComponent as ServerErrorSvg } from '../../../../assets/server-error.svg';

// Components
import { Modal, Content } from '../..';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { FormActions, FormActionsItem } from '../../Forms';
import { getCentralOffset } from '../../../../lib/datetime';

// Helpers
import { selectModalData } from '../../../../reducers/modal/modalSelectors';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Styles
import './service-down-error-modal.scss';

const ServiceDownModal = () => {
  const dispatch = useDispatch();
  const errorCode = (useSelector(selectModalData) || {})['errorCode'];
  const errorMap = {
    MGMW_EX_4003: 'TDLR',
  };

  let errorCodeKey;
  let errorCodeValue;
  if (errorCode && Array.isArray(errorCode)) {
    [errorCodeKey, errorCodeValue] = errorCode;
  } else {
    errorCodeKey = errorCode;
  }

  const serviceDownName = errorMap[errorCodeKey];
  return (
    <Modal
      name="ServiceDownModal"
      className="modal-sm server-error-modal"
      disableOnClickOutside
      disableCloseButton
    >
      <h2 className="h1 modal-title">
        <Content type="Errors" id="ServiceDownModal_Title" />
      </h2>
      <div className="modal-content">
        <div className="modal-graphic">
          <ServerErrorSvg role="presentation" />
        </div>
        {serviceDownName && (
          <>
            <>
              <p>
                <span className="highlight">{serviceDownName}</span>{' '}
                <Content type="Errors" id="ServiceDownModal_Content" />
                {` `}
                {errorCodeValue && (
                  <span className="highlight">
                    {errorCodeValue}
                    {` `}
                    {getCentralOffset()}
                  </span>
                )}
              </p>
              <FormActions align="center">
                <FormActionsItem>
                  <ButtonPrimary
                    onClick={() => {
                      dispatch(closeModal('ServiceDownModal'));
                      dispatch(replace('/'));
                    }}
                  >
                    <Content type="Labels" id="BackToDashboard" />
                  </ButtonPrimary>
                </FormActionsItem>
              </FormActions>
            </>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ServiceDownModal;
